import React from 'react';
import Header from './components/Header';
import StarField from './components/StarField';
import ArticleCreator from './components/ArticleCreator';
import { STAR_COUNT } from './constants';

/**
 * Main App Component
 * News Article Creator for Fantasy Sports Platform
 */
function App() {
  return (
    <div className="min-vh-100 position-relative" style={{ background: 'transparent' }}>
      <StarField starCount={STAR_COUNT} />

      <Header />

      <main className="container py-4 position-relative" style={{ zIndex: 10 }}>
        <div className="row justify-content-center">
          <div className="col-12 col-xl-10">
            <ArticleCreator />
          </div>
        </div>
      </main>
    </div>
  );
}

export default App;
